module.exports = __webpack_public_path__ + "img/monitor.083848e2.svg";